import type { Prompt } from '@/types';
import { PromptItem } from './PromptItem';

interface ListSectionProps {
  title: string;
  items: Prompt[];
}

export function ListSection({ title, items }: ListSectionProps) {
  if (!items || items.length === 0) return null;

  return (
    <section
      className='space-y-2 pr-4
'
    >
      <h3 className='text-md font-semibold'>{title}</h3>
      <div className='space-y-3'>
        {items.map(prompt => (
          <PromptItem key={prompt.id} prompt={prompt} />
        ))}
      </div>
    </section>
  );
}

export default ListSection;
